import axios from '@/libs/api.request'
import config from '@/config'

const privateCloudBaseUrl = config.basePrivateCloudUrl + '/cloud/api/v1/'

export const getPrivateCloudNode = (params) => {
  return axios.request({
    url: privateCloudBaseUrl + 'node/',
    params: params,
    method: 'get'
  })
}

export const detailPrivateCloudNode = (id) => {
  return axios.request({
    url: `${privateCloudBaseUrl}node/${id}/`,
    method: 'get'
  })
}

export const getPrivateCloudNodeInfo = (params) => {
  return axios.request({
    url: `${privateCloudBaseUrl}node/info/`,
    params: params,
    method: 'get'
  })
}

export const renewPrivateCloudNode = (data) => {
  return axios.request({
    url: `${privateCloudBaseUrl}node/renew/`,
    data: data,
    method: 'post'
  })
}

export const clearPrivateCloudNode = (data) => {
  return axios.request({
    url: `${privateCloudBaseUrl}node/clear/`,
    data: data,
    method: 'delete'
  })
}

export const checkPrivateCloudNodeHaveCloud = (params) => {
  return axios.request({
    url: `${privateCloudBaseUrl}node/have_cloud/`,
    params: params,
    method: 'get'
  })
}
